import type { UserInstrumentClassificationDto } from "@eu.mdotm.api/sphere";

/** A classification a constraint can be saved against: one without a uuid cannot be submitted. */
export type IdentifiedClassification = UserInstrumentClassificationDto & { classificationUuid: string };

export function userClassificationId(classificationUuid: string, value: string): string {
	return `${classificationUuid}-${value}`;
}

/**
 * Recovers the original `value` from a classification row id produced by {@link userClassificationId}
 * by stripping the known `${classificationUuid}-` prefix, so a value that itself contains hyphens
 * (e.g. "ULTRA-SHORT MUNICIPALS") comes back intact. An id without that prefix is returned unchanged.
 */
export function cleanClassificationId(classificationId: string, classificationUuid: string): string {
	const prefix = `${classificationUuid}-`;
	return classificationId.startsWith(prefix) ? classificationId.slice(prefix.length) : classificationId;
}
